import { getMarketProducts } from 'ducks/products';
import { useSelector } from 'react-redux';
import ProductCard from '../ProductCard/ProductCard';
import { List, ListItem } from '../menus/menuComponents';
import { Product } from '@inter-ikea-storageone/range';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import styled from 'styled-components';
import { usePlannerConfig } from 'contexts/plannerConfig';

const Wrapper = styled.div`
  padding: ${({ theme }) => `${theme.space.s} ${theme.space.xl}`};
`;

type Props = {
  searchString: string;
};

const SearchResult = ({ searchString }: Props) => {
  const products = useSelector(getMarketProducts);
  const searchParams = searchString.split(' ');
  const config = usePlannerConfig();
  const productTypes = config.plannerConfig.productGroups.flatMap(group => group.productTypes);

  const fields: (keyof Product)[] = [
    'name',
    'type',
    'typeName',
    'designText',
    'communicatedSizeText',
    'globalItemNo',
    'ruItemNo'
  ];

  const match = (product: Product, param: string) => {
    return fields.some(field => product[field]?.toLowerCase().includes(param.toLowerCase()));
  };

  const filteredProducts = products
    .filter(product => productTypes.includes(product.type))
    .filter(product => {
      return searchParams.every(param => {
        return match(product, param);
      });
    });

  return (
    <Wrapper>
      <List>
        {filteredProducts.map(product => (
          <ListItem key={product.coreProductId}>
            <ProductCard
              action="add"
              product={product}
              cardTitle="name"
              cardSubtitle="typeName, designText, communicatedSizeText"
              behaviors={{
                productClicked: [addProduct],
                productDropped: [addProduct]
              }}
            />
          </ListItem>
        ))}
        {filteredProducts.length === 0 && (
          <ListItem>
            <div>No results found</div>
          </ListItem>
        )}
      </List>
    </Wrapper>
  );
};

export default SearchResult;
